/* GN — box acquisto: il prezzo mostrato include la cornice scelta e l'etichetta dice cosa si compra
   ("A3 + cornice montata", oppure "Solo stampa A3" senza cornice). La variante si legge dal modulo d'acquisto (sempre aggiornato da Horizon),
   prezzi e nomi dal JSON nel blocco prezzo. Si ridipinge dopo ogni modifica del DOM. */
const euro = (cents) => `€${(Number(cents) / 100).toFixed(2).replace('.', ',')}`;
const frames = {}; // productId → { price, framed }

function currentVariantId(root) {
  const section = root.closest('.shopify-section') || document;
  const input = section.querySelector('product-form-component form [name="id"], form[action*="/cart/add"] [name="id"]');
  return input?.value || new URLSearchParams(location.search).get('variant');
}

function paint(root) {
  let variants;
  try { variants = JSON.parse(root.querySelector('[data-gn-variants]')?.textContent || '{}'); } catch { return; }
  const variant = variants[currentVariantId(root)] || Object.values(variants)[0];
  if (!variant) return;
  const frame = frames[root.dataset.productId] || { price: 0, framed: false };
  const total = variant.price + frame.price;
  const set = (el, text) => { if (el && el.textContent !== text) el.textContent = text; };
  set(root.querySelector('.gn-product-price__price .price'), euro(total));
  set(root.querySelector('[data-gn-rate-amount]'), euro(Math.floor(total / (Number(root.dataset.gnRates) || 3))));
  let label = variant.short;
  if (frame.framed) label += ` + ${root.dataset.gnFrameLabel || 'cornice'}`;
  // Prodotto con selettore cornice = stampa: "Solo stampa" su ogni formato, anche senza cornice (70×100).
  // Letto dalla pagina, perché il primo annuncio del selettore può arrivare prima che questo script ascolti
  else if (document.querySelector(`cornice-selector[data-product-id="${root.dataset.productId}"]`)) {
    label = `${root.dataset.gnPrintOnlyLabel || 'Solo stampa'} ${label}`;
  }
  set(root.querySelector('[data-gn-buy-label]'), label);
}

const paintAll = () => document.querySelectorAll('product-price [data-gn-variants]').forEach((s) => paint(s.closest('product-price')));

document.addEventListener('gn:cornice-change', (event) => {
  const { productId, price, framed } = event.detail || {};
  if (!productId) return;
  frames[productId] = { price: price || 0, framed: Boolean(framed) };
  paintAll();
});
document.addEventListener('change', () => requestAnimationFrame(paintAll));

let queued = false;
new MutationObserver(() => {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => { queued = false; paintAll(); });
}).observe(document.body, { childList: true, subtree: true, characterData: true });
paintAll();
